'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ScenarioManagementDirective = function ScenarioManagementDirective($rootScope, currentStateCriteriaService, scenarioService, $log) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/scenario-management.html'),
    controller: 'ScenarioManagementController',
    scope: {
      'screen': '@'
    },
    link: function link($scope, element) {
      var errorTemplate = _.template(require('../templates/error-message.html'));
      $scope.onDateChange = function (date, scenario) {
        $scope.loadSearchCriteria($scope.screen, date).then(function (response) {
          currentStateCriteriaService.loadSearchCriteria(response, false);
          $rootScope.$broadcast('search-criteria:forceSearch', scenario);
          element.modal('hide');
        });
      };
      $scope.saveToProduction = function (scenario) {
        element.modal('hide');
        scenarioService.saveToProduction(scenario).then(function () {
          toastr.success('Scenario successfully saved to production.');
        })["catch"](function (response) {
          var errorMsg = errorTemplate({
            'response': response,
            'operation': 'Save to production'
          });
          $log.error('ScenarioManagementDirective: saveToProduction - ' + errorMsg);
          toastr.error(errorMsg);
        });
      };
      $scope.$on('scenarios:loaded', $scope.loadScenarioList);
      element.on('show.bs.modal', $scope.onWindowShow);
    }
  };
};
ScenarioManagementDirective.$inject = ['$rootScope', 'CurrentStateCriteriaService', 'ScenarioService', '$log'];
module.exports = ScenarioManagementDirective;